"use strict";

var AbstractApi = require("./AbstractApi");

var PledgeStatementApi = class extends AbstractApi {
	//Call made to SO API
	submitPledgeStatement(pledgeStatementData) {
		return this.post({
			data: pledgeStatementData,
			url: "/api/pledgestatementsessions"
		});
	}
};

module.exports = new PledgeStatementApi();
